import Dispatcher from 'dispatcherjs';
// If you can avoid it, please don't use relative paths.
import { isSSR } from 'util/ssr';
import { bpTablet, bpDesktop, bpDesktopXl } from '../app/breakpoints';

export class MediaQueries {
    constructor(dispatcher) {
        if (isSSR()) return;
        this.events = dispatcher || new Dispatcher();

        this.createMqs();
        this.mqEvents();

        this.current = false;
        this.breakpointHandler();
    }

    createMqs() {
        if (isSSR()) return;
        this.mqTablet = window.matchMedia(`(min-width: ${bpTablet}px)`);
        this.mqDesktop = window.matchMedia(`(min-width: ${bpDesktop}px)`);
        this.mqDesktopXl = window.matchMedia(`(min-width: ${bpDesktopXl}px)`);
    }

    mqEvents() {
        if (isSSR()) return;
        this.mqTablet.addListener(() => this.breakpointHandler());
        this.mqDesktop.addListener(() => this.breakpointHandler());
        this.mqDesktopXl.addListener(() => this.breakpointHandler());
    }

    breakpointHandler() {
        if (isSSR()) return;
        let breakpoint = false;

        if (this.mqDesktopXl.matches) {
            breakpoint = 'desktop-xl';
        } else if (this.mqDesktop.matches) {
            breakpoint = 'desktop';
        } else if (this.mqTablet.matches) {
            breakpoint = 'tablet';
        } else {
            breakpoint = 'mobile';
        }

        if (this.current !== breakpoint) {
            this.current = breakpoint;
            this.events.emit('changed', breakpoint);
        }
    }

    isMobile() {
        if (isSSR()) return false;
        return !this.mqTablet.matches && !this.mqDesktop.matches;
    }

    isTablet() {
        if (isSSR()) return false;
        return this.mqTablet.matches && !this.mqDesktop.matches;
    }

    isDesktop() {
        if (isSSR()) return false;
        return this.mqDesktop.matches;
    }

    isDesktopXl() {
        return this.mqDesktopXl.matches;
    }
}

export const mediaQueries = new MediaQueries();
